export default {
      id: "cluster-usage",
      viewBox: "0 0 58 58",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#cluster",
      toString: function () {
        return this.url;
      }
    }